<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <div class="RechargeInfo" v-if="rechargeId">
        <div style="margin: 15px;border-radius:10px;overflow:hidden">
          <van-field
            readonly 
            :label="$t('recharge.info[0]')"
          >
            <template #input>
              {{InitData.currency}}<em>{{$Util.MoneyFormat(rechargeData.money||0)}}</em>
            </template>
          </van-field>
          <div class="rate-tips" v-if="rechargeData.mode=='virtual'" v-html="$t('recharge.tips[8]',{currency:InitData.currency,rate: InitData.setting.usdtRate, price: rechargeData.money, money: (rechargeData.money*InitData.setting.usdtRate).toFixed(2)})"></div>
          <van-field 
            readonly 
            :label="$t('recharge.info[1]')" 
            :value="rechargeData.orderNumber"
          >
            <template #button>
              <span id="IosOrder" style="position: absolute;opacity: 0">{{rechargeData.orderNumber}}</span>
              <input id="AppOrder" type="text" readonly :value="rechargeData.orderNumber" style="position: absolute;opacity: 0">
              <van-button size="mini" type="primary" @click="$Util.CopyText('IosOrder','AppOrder')">{{$t('recharge.info[5]')}}</van-button>
            </template>
          </van-field>
          <van-field 
            :label="$t('recharge.info[7]')"
          >
            <template #input>
              <van-uploader v-model="fileList" :show-upload="false" readonly :deletable="false" />
            </template>
          </van-field>
          <van-field 
            readonly 
            :label="$t('recharge.info[11]')" 
            :value="rechargeData.remarks"
            v-if="rechargeData.remarks"
          />
        </div>
        <!-- <div style="padding: 16px 16px 0">
          <van-button type="danger" block round style="font-size: 16px" @click="setOrderInfo">{{$t('recharge.info[8]')}}</van-button>
        </div> -->
        <!-- <van-divider :hairline="false" style="text-align: center;margin: 10px 0" v-if="rechargeData&&rechargeData.receive.length"><span v-html="$t('recharge.tips[0]')"></span></van-divider>
        <van-divider :hairline="false" style="text-align: center;margin: 10px 0" v-else><span v-html="$t('recharge.tips[5]')"></span></van-divider> -->
        <van-panel :title="$t('recharge.info[6]',{type:item.typeName})" :desc="item.qrcode?$t('recharge.tips[1]'):$t('recharge.tips[2]')" v-for="(item,index) in rechargeData.receive" :key="item.id" :border="false">
          <div v-if="item.qrcode">
            <van-field 
              :border="false" 
              readonly 
              :value="item.rececode" 
              :label="$t('recharge.info[12]')"
            >
              <template #button>
                <span :id="`IosAccount${index}`" style="position: absolute;opacity: 0">{{item.rececode}}</span>
                <input :id="`AppAccount${index}`" type="text" readonly :value="item.rececode" style="position: absolute;opacity: 0">
                <van-button size="mini" type="primary" @click="$Util.CopyText(`IosAccount${index}`,`AppAccount${index}`)">{{$t('recharge.info[5]')}}</van-button>
              </template>
            </van-field>
            <div class="code">
              <van-image
                width="50%"
                :src="`${InitData.setting.up_url}${item.qrcode}`"
              />
              <p>{{$t('recharge.info[13]')}}</p>
            </div>
          </div>
          <div v-else>
            <van-field 
              :border="false" 
              readonly 
              :value="item.recename" 
              :label="$t('recharge.info[4]')"
            >
              <template #button>
                <span :id="`IosName${index}`" style="position: absolute;opacity: 0">{{item.recename}}</span>
                <input :id="`AppName${index}`" type="text" readonly :value="item.recename" style="position: absolute;opacity: 0">
                <van-button size="mini" type="primary" @click="$Util.CopyText(`IosName${index}`,`AppName${index}`)">{{$t('recharge.info[5]')}}</van-button>
              </template>
            </van-field>
            <van-field
              :border="false" 
              readonly 
              :value="item.bank" 
              :label="$t('recharge.info[2]')"
            >
              <template #button>
                <span :id="`IosBank${index}`" style="position: absolute;opacity: 0">{{item.bank}}</span>
                <input :id="`AppBank${index}`" type="text" readonly :value="item.bank" style="position: absolute;opacity: 0">
                <van-button size="mini" type="primary" @click="$Util.CopyText(`IosBank${index}`,`AppBank${index}`)">{{$t('recharge.info[5]')}}</van-button>
              </template>
            </van-field>
            <van-field 
              :border="false" 
              readonly 
              :value="item.rececode" 
              :label="$t('recharge.info[3]')"
            >
              <template #button>
                <span :id="`IosAccount${index}`" style="position: absolute;opacity: 0">{{item.rececode}}</span>
                <input :id="`AppAccount${index}`" type="text" readonly :value="item.rececode" style="position: absolute;opacity: 0">
                <van-button size="mini" type="primary" @click="$Util.CopyText(`IosAccount${index}`,`AppAccount${index}`)">{{$t('recharge.info[5]')}}</van-button>
              </template>
            </van-field>
            <van-field
              v-if="item.open_bank"
              :border="false" 
              readonly 
              :value="item.open_bank" 
              :label="$t('recharge.info[9]')"
            >
              <template #button>
                <span :id="`IosIFSC${index}`" style="position: absolute;opacity: 0">{{item.open_bank}}</span>
                <input :id="`AppIFSC${index}`" type="text" readonly :value="item.open_bank" style="position: absolute;opacity: 0">
                <van-button size="mini" type="primary" @click="$Util.CopyText(`IosIFSC${index}`,`AppIFSC${index}`)">{{$t('recharge.info[5]')}}</van-button>
              </template>
            </van-field>
            <van-field
              v-if="item.upi"
              :border="false" 
              readonly
              :value="item.upi" 
              :label="$t('recharge.info[10]')"
            >
              <template #button>
                <span :id="`IosUpi${index}`" style="position: absolute;opacity: 0">{{item.upi}}</span>
                <input :id="`AppUpi${index}`" type="text" readonly :value="item.upi" style="position: absolute;opacity: 0">
                <van-button size="mini" type="info" round plain @click="$Util.CopyText(`IosUpi${index}`,`AppUpi${index}`)">{{$t('recharge.info[5]')}}</van-button>
              </template>
            </van-field>
          </div>
        </van-panel>
        <van-divider :hairline="false">{{$t('recharge.tips[3]')}}</van-divider>
        <van-divider :hairline="false">{{$t('recharge.tips[4]')}}</van-divider>
      </div>
      <div v-else>
        <div v-if="!showPrice">
          <van-divider style="font-size: 14px">
            <i18n path="recharge.default[3]">
              <em style="color:var(--color-important);" slot="money">{{InitData.currency}}{{$Util.MoneyFormat(UserInfo.balance)}}</em>
            </i18n>
          </van-divider>
          <van-cell-group class="RechargeList" :border="false" v-if="rechargeList">
            <van-cell v-for="item in rechargeList" :key="item.id" is-link @click="selectType(item.id)">
              <template #icon>
                <img :src="`./static/icon/${item.mode}.png`" height="40" style="border-radius: 100%;margin-right: 10px">
              </template>
              <template #title>
                <b>{{item.name}}</b>
              </template>
              <template #label>
                {{$t('recharge.default[4]',{currency:item.mode=='virtual'?InitData.setting.virtual:InitData.currency,min:$Util.MoneyFormat(item.minPrice),max:$Util.MoneyFormat(item.maxPrice),fee:item.fee})}}
              </template>
            </van-cell>
          </van-cell-group>
          <div style="padding:0 15px 15px" v-html="InitData.recharge_instructions"></div>
        </div>
        <div v-else class="mt10">
          <div class="RechargeInfo" v-if="siteBank.length">
            <van-divider :hairline="false" style="text-align: center;margin: 10px 0">{{$t('recharge.tips[6]')}}</van-divider>
            <van-panel :title="$t('recharge.info[6]',{type:item.bank})" :desc="item.qrcode?$t('recharge.tips[1]'):$t('recharge.tips[2]')" v-for="(item,index) in siteBank" :key="item.id" :border="false">
              <van-field 
                :border="false" 
                readonly 
                :value="item.recename" 
                :label="$t('recharge.info[4]')"
              >
                <template #button>
                  <span :id="`IosName${index}`" style="position: absolute;opacity: 0">{{item.recename}}</span>
                  <input :id="`AppName${index}`" type="text" readonly :value="item.recename" style="position: absolute;opacity: 0">
                  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosName${index}`,`AppName${index}`)">{{$t('recharge.info[5]')}}</van-button>
                </template>
              </van-field>
              <van-field
                :border="false" 
                readonly 
                :value="item.bank" 
                :label="$t('recharge.info[2]')"
              >
                <template #button>
                  <span :id="`IosBank${index}`" style="position: absolute;opacity: 0">{{item.bank}}</span>
                  <input :id="`AppBank${index}`" type="text" readonly :value="item.bank" style="position: absolute;opacity: 0">
                  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosBank${index}`,`AppBank${index}`)">{{$t('recharge.info[5]')}}</van-button>
                </template>
              </van-field>
              <van-field 
                :border="false" 
                readonly 
                :value="item.rececode" 
                :label="$t('recharge.info[3]')"
              >
                <template #button>
                  <span :id="`IosAccount${index}`" style="position: absolute;opacity: 0">{{item.rececode}}</span>
                  <input :id="`AppAccount${index}`" type="text" readonly :value="item.rececode" style="position: absolute;opacity: 0">
                  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosAccount${index}`,`AppAccount${index}`)">{{$t('recharge.info[5]')}}</van-button>
                </template>
              </van-field>
              <van-field
                v-if="item.open_bank"
                :border="false" 
                readonly 
                :value="item.open_bank" 
                :label="$t('recharge.info[9]')"
              >
                <template #button>
                  <span :id="`IosIFSC${index}`" style="position: absolute;opacity: 0">{{item.open_bank}}</span>
                  <input :id="`AppIFSC${index}`" type="text" readonly :value="item.open_bank" style="position: absolute;opacity: 0">
                  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosIFSC${index}`,`AppIFSC${index}`)">{{$t('recharge.info[5]')}}</van-button>
                </template>
              </van-field>
              <van-field
                v-if="item.upi"
                :border="false" 
                readonly
                :value="item.upi" 
                :label="$t('recharge.info[10]')"
              >
                <template #button>
                  <span :id="`IosUpi${index}`" style="position: absolute;opacity: 0">{{item.upi}}</span>
                  <input :id="`AppUpi${index}`" type="text" readonly :value="item.upi" style="position: absolute;opacity: 0">
                  <van-button size="mini" type="info" round plain @click="$Util.CopyText(`IosUpi${index}`,`AppUpi${index}`)">{{$t('recharge.info[5]')}}</van-button>
                </template>
              </van-field>
            </van-panel>
          </div>
          <div class="RechargeInfo" v-if="virtualList.length">
            <van-divider :hairline="false" style="text-align: center;margin: 10px 0">{{$t('recharge.tips[6]')}}</van-divider>
            <van-panel :title="$t('recharge.info[6]',{type:item.name})" :desc="item.qrcode?$t('recharge.tips[1]'):$t('recharge.tips[2]')" v-for="(item,index) in virtualList" :key="item.id" :border="false">
              <van-field 
                :border="false" 
                readonly 
                :value="item.account" 
                :label="$t('recharge.info[12]')"
              >
                <template #button>
                  <span :id="`IosAccount${index}`" style="position: absolute;opacity: 0">{{item.account}}</span>
                  <input :id="`AppAccount${index}`" type="text" readonly :value="item.account" style="position: absolute;opacity: 0">
                  <van-button size="mini" type="primary" @click="$Util.CopyText(`IosAccount${index}`,`AppAccount${index}`)">{{$t('recharge.info[5]')}}</van-button>
                </template>
              </van-field>
              <div class="code">
                <van-image
                  width="50%"
                  :src="item.qrcode"
                />
                <p>{{$t('recharge.info[13]')}}</p>
              </div>
            </van-panel>
          </div>
          <div style="margin: 0 12px;border-radius:10px;overflow:hidden">
            <van-field
              :label="$t('recharge.label[0]')" 
              size="large"
              label-width="80"
              v-if="rechargeInfo.fixed"
            >
              <template #input>
                <van-radio-group v-model="postData.money">
                  <a v-for="item,index in rechargeInfo.fixed.split(',')" :key="index" class="radio" :class="{active:item==postData.money}" href="javascript:;" @click="postData.money=item">
                    {{$Util.MoneyFormat(item)}}
                    <van-radio v-show="false" :name="item" />
                  </a>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              type="number"
              :label="$t('recharge.label[0]')" 
              :placeholder="$t('recharge.placeholder[0]')" 
              size="large"
              label-width="80"
              :value="$Util.MoneyFormat(postData.money)"
              @input="inputMoney"
            />
            <div v-if="rechargeInfo.mode=='virtual'&&postData.money" class="rate-tips"  v-html="$t('recharge.tips[8]',{currency:InitData.currency,rate: InitData.setting.usdtRate, price: postData.money, money: (postData.money*InitData.setting.usdtRate).toFixed(2)})"></div>
            <div v-if="Number(rechargeInfo.recharge_rebate)&&postData.money" class="rate-tips" style="padding-top: 0;">
              {{rechargeInfo.name}} {{$t('recharge.tips[9]')}}: {{(postData.money*InitData.setting.usdtRate).toFixed(2)}} × {{rechargeInfo.recharge_rebate}}% = {{InitData.currency}}<b>{{((postData.money*InitData.setting.usdtRate)*(rechargeInfo.recharge_rebate/100)).toFixed(2)}}</b>
            </div>
            <van-field
              size="large"
              :label="$t('recharge.label[1]')" 
              label-width="80"
              v-if="pickerList.length"
            >
              <template #input>
                <van-radio-group v-model="jumpData.result.bid" @change="onConfirm">
                  <a v-for="item,index in pickerList" :key="index" class="radio" :class="{active:item.id==jumpData.result.bid}" href="javascript:;" @click="jumpData.result.bid=item.id">
                    {{item.bank_name}}
                    <van-radio v-show="false" :name="item.id" />
                  </a>
                </van-radio-group>
              </template>
            </van-field>
            <van-field 
              v-model.trim="postData.name"
              type="text"
              :label="$t('recharge.label[2]')" 
              :placeholder="$t('recharge.placeholder[2]')" 
              size="large"
              label-width="80"
            />
            <van-field 
              :label="$t('recharge.info[7]')"
              v-if="rechargeInfo.mode=='turn'||rechargeInfo.mode=='turn_alipay'||rechargeInfo.mode=='turn_wx'||rechargeInfo.mode=='virtual'"
            >
              <template #input>
                <van-uploader v-model="fileList" multiple :after-read="afterRead" />
              </template>
            </van-field>
            <van-field 
              v-model.trim="upiData.pay_name"
              type="text"
              :label="$t('recharge.label[3]')" 
              :placeholder="$t('recharge.placeholder[5]')" 
              size="large"
              label-width="80"
              v-if="rechargeInfo.mode=='upi'"
            />
            <van-field 
              v-model.trim="upiData.pay_mobile"
              type="tel"
              :label="$t('recharge.label[4]')" 
              :placeholder="$t('recharge.placeholder[6]')" 
              size="large"
              label-width="80"
              v-if="rechargeInfo.mode=='upi'"
            />
            <van-field 
              v-model.trim="upiData.pay_account"
              type="text"
              :label="$t('recharge.label[5]')" 
              :placeholder="$t('recharge.placeholder[7]')" 
              size="large"
              label-width="80"
              v-if="rechargeInfo.mode=='upi'"
            />
            <van-field 
              v-model.trim="upiData.pay_email"
              type="text"
              :label="$t('recharge.label[6]')" 
              :placeholder="$t('recharge.placeholder[8]')" 
              size="large"
              label-width="80"
              v-if="rechargeInfo.mode=='upi'"
            />
          </div>
          <div style="padding: 20px 12px;">
            <van-button block type="danger" round :loading="isSubmit" :loading-text="$t('recharge.default[5]')" style="font-size: 16px;" @click="onSubmit">{{$t('recharge.default[6]')}}</van-button>
            <van-button block round style="font-size: 16px;margin-top: 10px;" @click="showPrice=false">{{$t('recharge.default[7]')}}</van-button>
          </div>
        </div>
      </div>
      <van-loading class="Loading" size="50" vertical v-if="isLoad">{{$t('recharge.default[8]')}}</van-loading>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Recharge',
  components: {

  },
  props: ['rechargeId'],
  data() {
    return {
      postData: {
        money: this.$route.query.amount||'',
        vip: this.$route.query.vip||'',
        recharge_id: '',
        name: '',
        screenshots: ''
      },
      rechargeList: '',
      pickerList: '',
      showPicker: false,
      isSubmit: false,
      rechargeData: '',
      rechargeInfo: '',
      showPrice: false,
      pickerName: '',
      jumpData: {
        result: {
          vip: this.$route.query.vip||'',
          bid: ''
        }
      },
      isLoad: true,
      fileList: [],
      upiData: {
        pay_name: '',
        pay_mobile: '',
        pay_account: '',
        pay_email: ''
      },
      siteBank: '',
      virtualList: '',
    }
  },
  computed: {

  },
  watch: {
    $route(){
      if(this.rechargeId){
        this.$parent.navBarTitle = this.$t('recharge.default[1]')
        this.getRechargeInfo()
      }else{
        this.$parent.navBarTitle = this.$t('recharge.default[0]')
        this.$Model.GetRechargeType(data=>{
          this.isLoad = false
          this.rechargeList = data.info
        })
      }
    },
  },
  created() {
    if(this.rechargeId){
      this.$parent.navBarTitle = this.$t('recharge.default[1]')
      this.getRechargeInfo()
    }else{
      this.$parent.navBarTitle = this.$t('recharge.default[0]')
      this.$Model.GetRechargeType(data=>{
        this.isLoad = false
        this.rechargeList = data.info
      })
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    inputMoney(val) {
      this.postData.money = val.replace(/\./g,"")
    },
    selectType(typeid) {
			this.fileList = []
      this.siteBank = ''
      this.postData = {
        money: this.$route.query.amount||'',
        vip: this.$route.query.vip||'',
        recharge_id: typeid,
        name: '',
        screenshots: ''
      }
      this.jumpData = {
        result: {
          vip: this.$route.query.vip||'',
          bid: ''
        }
      }
      this.rechargeInfo = this.rechargeList.find(item=>item.id==typeid)
      this.showPrice = true
      if(this.rechargeInfo.bankList){
        this.pickerList = this.rechargeInfo.bankList
      }else{
        this.pickerList = ''
      }
      if(this.rechargeInfo.qrcodeList){
        this.virtualList = this.rechargeInfo.qrcodeList
      }else{
        this.virtualList = ''
      }
      switch(this.rechargeInfo.mode) {
        case "virtual":
          if(this.$route.query.vip){
            this.postData.money = Math.ceil(this.postData.money/this.$store.state.InitData.setting.usdtRate)
          }
          break;
        case "wap":
        case "scan":
          this.jumpData.url = this.rechargeInfo.submitUrl
          this.jumpData.result = {
            vip: this.$route.query.vip||'',
            uid: this.UserInfo.userid,
            typeid: typeid,
            bid: '',
            scanType: ''
          }
          break;
        case "online":
        case "quick":
          this.jumpData.url = this.rechargeInfo.submitUrl
          this.jumpData.result = {
            vip: this.$route.query.vip||'',
            uid: this.UserInfo.userid,
            typeid: typeid,
            bid: '',
            bank_code: ''
          }
          break;
        case "turn":
        case "turn_alipay":
        case "turn_wx":
          this.$Model.GetPayBank({pay_id:typeid},data=>{
            if(data.code==1){
              this.siteBank = data.data
            }
          })
          break;
        case "upi":
          this.jumpData.url = this.rechargeInfo.submitUrl
          this.jumpData.result = {
            vip: this.$route.query.vip||'',
            uid: this.UserInfo.userid,
            typeid: typeid,
            bid: '',
            bank_code: '',
            pay_name: '',
            pay_mobile: '',
            pay_account: '',
            pay_email: ''
          }
          break;
      }
    },
    onConfirm(val) {
      switch(this.rechargeInfo.mode) {
        case "wap":
        case "scan":
          this.jumpData.result.scanType = this.rechargeInfo.bankList.find(item=>item.id==val).bank_code
          break;
        case "online":
        case "quick":
        case "upi":
          this.jumpData.result.bank_code = this.rechargeInfo.bankList.find(item=>item.id==val).bank_code
          break;
        case "upi":
          this.jumpData.result.bank_code = this.rechargeInfo.bankList.find(item=>item.id==val).bank_code
          break;
      }
    },
    onSubmit() {
      if(!this.postData.money){
        this.$Dialog.Toast(this.$t('recharge.placeholder[0]'));
        return;
      }
      if(Number(this.postData.money)<this.$Util.PointFormat(this.rechargeInfo.minPrice)){
        this.$Dialog.Toast(this.$t('recharge.placeholder[3]',{currency: this.InitData.currency,min:this.rechargeInfo.minPrice}));
        return;
      }
      if(Number(this.postData.money)>this.$Util.PointFormat(this.rechargeInfo.maxPrice)){
        this.$Dialog.Toast(this.$t('recharge.placeholder[4]',{currency: this.InitData.currency,max:this.rechargeInfo.maxPrice}));
        return;
      }
      switch(this.rechargeInfo.mode) {
        case "wap":
        case "scan":
        case "online":
        case "quick":
        case "upi":
          if(!this.jumpData.result.bid){
            this.$Dialog.Toast(this.$t('recharge.placeholder[1]'));
            return;
          }
          if(this.rechargeInfo.mode=='upi'){
            if(!this.upiData.pay_name){
              this.$Dialog.Toast(this.$t('recharge.placeholder[5]'));
              return;
            }
            if(!this.upiData.pay_mobile){
              this.$Dialog.Toast(this.$t('recharge.placeholder[6]'));
              return;
            }
            if(!this.upiData.pay_account){
              this.$Dialog.Toast(this.$t('recharge.placeholder[7]'));
              return;
            }
            if(!this.upiData.pay_email){
              this.$Dialog.Toast(this.$t('recharge.placeholder[8]'));
              return;
            }
            this.jumpData.result.pay_name = this.upiData.pay_name
            this.jumpData.result.pay_mobile = this.upiData.pay_mobile
            this.jumpData.result.pay_account = this.upiData.pay_account
            this.jumpData.result.pay_email = this.upiData.pay_email
          }
          this.jumpData.result.name = this.postData.name
          this.jumpData.result.price = this.postData.money
          const url = this.jumpData.url + '?' + $.param(this.jumpData.result)
          this.$Util.OpenUrl(url)
          this.$router.push('/user/wallet')
          break;
        default:
          if(!this.postData.name){
            this.$Dialog.Toast(this.$t('recharge.placeholder[2]'));
            return;
          }
          if(!this.fileList.length){
            this.$Dialog.Toast(this.$t('recharge.tips[7]'))
            return
          }
          this.postData.screenshots = this.fileList.flatMap(item=>item.url.replace(this.InitData.setting.up_url,''))
          this.isSubmit = true;
          this.$Model.RechargeOrder(this.postData,data=>{
            this.isSubmit = false;
            if(data.code==1){
              this.showPrice = false
            }
          })
      }
    },
    afterRead(file) {
      file.status = 'uploading'
      file.message = this.$t('upload[0]')
      this.uploadImgs(file)
    },
    compressImg(file) {
      this.$Util.CompressImg(file.file.type,file.content,750,(image)=>{
        let param = new FormData();
        param.append('token',localStorage['Token']);
        param.append('type',4);
        param.append('image',image,file.file.name);
        this.$Model.UploadImg(param,(data)=>{
          if(data.code==1){
            file.message = this.$t('upload[2]')
            file.status = 'success'
            file.url = data.url
          }else{
            file.status = 'failed'
            file.message = this.$t('upload[3]')
          }
        });
      })
    },
    uploadImgs(file){
      if(file.length){
        file.forEach(item=>{
          if (!item.file.type.match(/image/)){
            item.status = 'failed'
            item.message = this.$t('upload[1]')
            return;
          }
          this.compressImg(item)
        })
      }else{
        if (!file.file.type.match(/image/)){
          file.status = 'failed'
          file.message = this.$t('upload[1]')
          return;
        }
        this.compressImg(file)
      }
    },
    setOrderInfo() {
      const screenshots = this.fileList.flatMap(item=>item.url.replace(this.InitData.setting.up_url,''))
      this.$Model.SetOrderInfo({orderNumber: this.rechargeId,screenshots: screenshots},data=>{
        this.getRechargeInfo()
      })
    },
    getRechargeInfo() {
      this.$Model.GetRechargeInfo(this.rechargeId,data=>{
        this.isLoad = false
        this.rechargeData = data
        this.fileList = data.screenshots?data.screenshots.flatMap(item=>[{url: this.InitData.setting.up_url+item}]):[]
      })
    },
  }
}
</script>
<style scoped>
.RechargeList{
  margin-bottom: 20px;
}
.RechargeList .van-cell__title{
  line-height: 1;
}
.RechargeInfo .van-cell--large>>>.van-field__control{
  font-size:16px;
}
.RechargeInfo .van-cell .van-cell__value em{
  font-size: 20px;
  color: #4087f1;
}
.RechargeInfo .van-panel{
  margin: 12px;
  border-radius: 10px;
  overflow: hidden;
}
.RechargeInfo .van-panel__content .van-cell{
  padding: 0 16px;
  margin: 10px 0;
}
.RechargeInfo .van-panel__content>>>.van-field__control{
  text-align: left;
}
.RechargeInfo .van-panel__content img{
  width: 80%;
  margin: 0 auto;
  display: block;
}
.van-divider{
  font-size: 12px;
  line-height: 1.5;
}
.MoneyList{
  word-break: break-word;
}
.MoneyList .van-cell__value{
  flex: auto;
}
.MoneyList .van-radio{
  margin: 3px 6px 3px 0;
  position: relative;
  min-width: 45%;
  text-align: center;
  flex-direction: row-reverse;
}
.MoneyList .van-radio>>>.van-radio__icon--checked~.van-radio__label{
  color: var(--color-white);
}
.MoneyList .van-radio>>>.van-radio__label{
  
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview-image{
  width: 60px;
  height: 60px;
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview{
  margin: 4px 8px 4px 0;
  background-color: #f7f8fa;
  border-radius: 8px;
}
.van-field{
  padding: 16px;
}
.van-field>>>.van-field__label{
  font-weight: 600;
  color: var(--color-active);
}
.van-panel__content>>>.van-field__label{
  font-weight: 400;
}
.van-radio-group{
  display: flex;
  flex-wrap: wrap;
}
.radio {
  color: var(--color-assist);
  border-radius: 3px;
  padding: 8px 10px;
  line-height: 1;
  font-size: 14px;
  min-width: 45%;
  margin: 5px 10px 5px 0;
  text-align: center;
  border: 1px solid var(--border-color-main);
}
.radio.active{
  color: var(--color-white);
  background-color: var(--color-active);
  border-color: var(--color-active);
}
.RechargeInfo .van-panel .code{
  text-align: center;
  font-size: 14px;
  padding-bottom: 15px;
}
.RechargeInfo .van-panel .code p{
  margin-top: 5px;
}
.RechargeInfo .van-field>>>.van-field__label{
  color: var(--color-assist);
  font-size: 13px;
}
.rate-tips{
  color: var(--color-assist);
  padding: 10px 16px;
  font-size: 12px;
}
.rate-tips>>>b{
  color: var(--color-important);
}
</style>